<template>
</template>

<script>
    import ProductService from '../../../providers/api/product-service';

    const productService = new ProductService();

    export default {
        name: "register-product-view",
        props: ['productId'],
        mounted() {
            this.viewProduct();
        },
        methods: {
            viewProduct() {
                productService.doRegisterView(this.productId);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// resources/site/js/components/pages/product/register-view.vue